import { atom } from 'recoil';

import { RechargeStatus } from '@/types';

/**
 * 充值订单状态表
 * key: orderNo
 * value: 订单状态（PENDING / PAID / CLOSED / FAILED）
 */
export const rechargeOrderStatusState = atom<Record<string, RechargeStatus>>({
  key: 'rechargeOrderStatusState',
  default: {},
});

